import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router';
import { QueryParamProvider } from 'use-query-params';
import CustomReactRouter7Adapter from '../../src/utilities/custom_react_router_7_adapter';
import SignupApp from '../../src/membership_flow/apps/signup_app';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';

document.addEventListener('DOMContentLoaded', () => {
  const signupContainer = document.getElementById(
    'membership-flow-signup-react-app'
  );
  if (!signupContainer) return;

  // RENDERING INITIAL FORM FOR SIGNUP
  // CORRESPONDING TEMPLATES
  // default app/views/register/default.html.slim
  // PRO app/views/register/pro.html.slim
  // CA app/views/register/ca.html.slim

  // Given the #membership-flow-signup-react-app HTML node data attributes,
  // pass all these required props for the <SignupApp /> flow
  if (signupContainer) {
    const {
      authToken,
      isSignedIn,
      packageShortName,
      paymentPage,
      returnTo,
      text1,
      text2,
    } = signupContainer.dataset;

    const signupRoot = createRoot(signupContainer);

    signupRoot.render(
      <DevexHighOrderComponent>
        <BrowserRouter>
          <QueryParamProvider adapter={CustomReactRouter7Adapter}>
            <Routes>
              <Route
                path='/register/:package_short_name/*'
                element={
                  <SignupApp
                    authToken={authToken}
                    isSignedIn={isSignedIn === 'true'}
                    packageShortName={packageShortName}
                    paymentPage={paymentPage}
                    returnTo={returnTo}
                    text1={text1}
                    text2={text2}
                  />
                }
              />
            </Routes>
          </QueryParamProvider>
        </BrowserRouter>
      </DevexHighOrderComponent>
    );
  }
});
